import css from 'styled-jsx/css';

const styles = css.global`#canais-atendimento-servicos {
    position: relative;
    overflow: hidden;
}

#canais-atendimento-servicos .is-desk {
    display: none;
}

#canais-atendimento-qrcode {
    position: relative;
    margin-bottom: 64px;
    z-index: 99;
}

#canais-atendimento-qrcode .canais-atendimento-paragrafo {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    max-width: 713px;
    margin: 0;
}

#canais-atendimento-qrcode .canais-atendimento-paragrafo b {
    font-weight:600 ;
}

#canais-atendimento-qrcode .canais-atendimento-paragrafo .only-desk {
    display: none;
}

#canais-atendimento-qrcode .canais-atendimento-paragrafo .only-mobile {
    display: inline;
}

#canais-atendimento-qrcode .canais-atendimento-qrcode {
    display: none;
}

#canais-atendimento-qrcode .canais-atendimento-btn {
    width: 272px;
    height: 48px;
    max-width: 334px;
    margin: 24px auto 24px;
}

#canais-atendimento-servicos {
    padding-bottom: 24px;
}

#canais-atendimento-servicos .canais-conteudos-slide-titulo {
    color: #444;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 28px;
    max-width: 210px;
}

#canais-atendimento-servicos .canais-conteudos-negrito {
    color: #C00;
    font-family: "SantanderText";
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 28px;
    min-height: 56px;
    display: flex;
    align-items: center;
}

#canais-atendimento-servicos .custom-carousel.fill-height {
    margin-bottom: 40px;
    z-index: 9;
}

#canais-atendimento-servicos .content-card {
    display: flex;
    margin-bottom: 16px;
}

#canais-atendimento-servicos .img-card {
    margin-right: 16px;
}

#canais-atendimento-servicos .custom-carousel .embla__slide {
    max-width: 220px;
    margin-right: 8px;
}

#canais-atendimento-servicos .canais-atendimento-img {
    width: 220px;
    height: 203.649px;
    margin-right: 24px;
}

#canais-atendimento-servicos .home-pagination {
    z-index: 2;
    position: relative;
}

#canais-atendimento-servicos .canais-atendimento-content-wpp {
    padding-top: 48px;
    display: flex;
    overflow: auto;
    scrollbar-width: none;
    /* Firefox */
    -ms-overflow-style: none;
    /* Internet Explorer e Edge */
    z-index: 2;
    position: relative;
}

#canais-atendimento-servicos .canais-atendimento-content-wpp::-webkit-scrollbar {
    display: none;
    /* Chrome, Safari e Edge */
}

#canais-atendimento-servicos .area-cliente-santander-img {
    position: absolute;
    opacity: .1;
    left: 0;
    bottom: 0;
    z-index: 0;
}

.is-mob, 
.is-desk {
    z-index: 99;
}


@media(min-width: 992px) {
    #canais-atendimento-servicos .content-desk,
    #canais-atendimento-servicos .is-desk    {
        display: flex;
        z-index: 99;
    }

    #canais-atendimento-servicos .is-mob {
        display: none;
    }

    #canais-atendimento-qrcode {
        margin-bottom: 94px;
    }

    #canais-atendimento-qrcode .canais-atendimento-paragrafo .only-desk {
        display: inline;
    }

    #canais-atendimento-qrcode .canais-atendimento-paragrafo .only-mobile {
        display: none;
    }

    #canais-atendimento-qrcode .canais-atendimento-qrcode {
        display: block;
        position: absolute;
        top: 0;
        margin: 0;
        right: 6%;
        width: 201px;
    }

    #canais-atendimento-servicos .area-cliente-santander-img {
        position: absolute;
        opacity: .1;
        bottom: 0;
        right: 0;
        left: unset;
    }

    #canais-atendimento-qrcode .canais-atendimento-btn {
        margin: 24px 0;
    }

    #canais-atendimento-servicos .canais-conteudos-slide-titulo {
        max-width: 302px;
    }
    #canais-atendimento-servicos .canais-conteudos-negrito {
        min-height: auto;
    }

    #canais-atendimento-servicos .canais-atendimento-content-servicos {
        display: flex;
        width: 60%;
        margin-right: 10%;
        height: 543px;
    }

    #canais-atendimento-servicos .canais-atendimento-content-imgs {
        width: 30%;
        display: flex;
        flex-direction: column;
        align-items: flex-end;
    }

    #canais-atendimento-servicos .canais-atendimento-img {
        width: 294px;
        height: 274px;
        margin-bottom: 40px;
    }

    /* #canais-atendimento-servicos .canais-slide {
        width: 278px;
    } */

    #canais-atendimento-servicos .canais-atendimento-content-servicos {
        flex-wrap: wrap;
        justify-content: space-between;
        gap: 56px;
    }
}

@media(min-width: 992px) and (max-width: 1065px) {
    #canais-atendimento-qrcode .canais-atendimento-paragrafo {
        max-width: 600px;
    }
}

@media(min-width: 992px) and (max-width: 1115px) {
    #canais-atendimento-servicos .canais-slide {
        width: 240px;
    }
}`;

export default styles;